import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import SocialSidebar from './components/SocialSidebar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import Digital from './pages/Digital';
import Print from './pages/Print';
import Television from './pages/Television';
import Theatre from './pages/Theatre';
import Portfolio from './pages/Portfolio';
import Industries from './pages/Industries';
import AboutUs from './pages/AboutUs';
import ReachUs from './pages/ReachUs';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <SocialSidebar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/digital" element={<Digital />} />
          <Route path="/digital-marketing" element={<Digital />} />
          <Route path="/print" element={<Print />} />
          <Route path="/television" element={<Television />} />
          <Route path="/theatre" element={<Theatre />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contact" element={<ReachUs />} />
          <Route path="/reachus" element={<ReachUs />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
